/* unplugin-vue-components disabled */import { render } from "./ExitReserve.vue?vue&type=template&id=2485f3da"
import script from "./ExitReserve.vue?vue&type=script&lang=js"
export * from "./ExitReserve.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__